import { useApi } from "./api";

interface AutoSelectResponse {
  account_created: boolean;
  account_id: string;
  account_name: string;
}

export function useAccountService() {
  const api = useApi();

  return {
    /**
     * Auto-select an account for the current user
     * This will return the account ID and whether the account was just created
     */
    async autoSelectAccount(): Promise<AutoSelectResponse> {
      return api.post<AutoSelectResponse>("/bff/accounts/auto-select", {});
    },
  };
}
